import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.CompareA');
    const itemsA = [
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744280625524/compare_1.png',
                    label: t('product_label'),
                    title: t('product1_main_title'),
                    lHref: 'https://jp.ecoflow.com/products/ecoflow-500w-alternator-charger',
                    lChildren: t('product_btn'),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: t('product1_main_title'),
                        position: `Product Detail`,
                    },
                    specItems: [
                        {
                            title: t('product1_title1'),
                            desc: t('product1_desc1'),
                        },
                        {
                            title: t('product1_title2'),
                            desc: t('product1_desc2'),
                        },
                        {
                            title: t('product1_title3'),
                            desc: t('product1_desc3'),
                        },
                        {
                            title: t('product1_title4'),
                            desc: t('product1_desc4'),
                        },
                        {
                            title: t('product1_title5'),
                            desc: t('product1_desc5'),
                        },
                        {
                            title: t('product1_title6'),
                            desc: t('product1_desc6'),
                        },
                        {
                            title: t('product1_title7'),
                            desc: t('product1_desc7'),
                        },
                        {
                            title: t('product1_title8'),
                            desc: t('product1_desc8'),
                        },
                        {
                            title: t('product1_title9'),
                            desc: t('product1_desc9'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744102074090/compare_2.png',
                    title: t('product2_main_title'),
                    lHref: 'https://jp.ecoflow.com/products/ecoflow-800w-alternator-charger',
                    lChildren: t('product_btn'),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: t('product2_main_title'),
                        position: `Product Detail`,
                    },
                    specItems: [
                        {
                            title: t('product2_title1'),
                            desc: t('product2_desc1'),
                        },
                        {
                            title: t('product2_title2'),
                            desc: t('product2_desc2'),
                        },
                        {
                            title: t('product2_title3'),
                            desc: t('product2_desc3'),
                        },
                        {
                            title: t('product2_title4'),
                            desc: t('product2_desc4'),
                        },
                        {
                            title: t('product2_title5'),
                            desc: t('product2_desc5'),
                        },
                        {
                            title: t('product2_title6'),
                            desc: t('product2_desc6'),
                        },
                        {
                            title: t('product2_title7'),
                            desc: t('product2_desc7'),
                        },
                        {
                            title: t('product2_title8'),
                            desc: t('product2_desc8'),
                        },
                        {
                            title: t('product2_title9'),
                            desc: t('product2_desc9'),
                        },
                    ],
                },
            ],
        },
    ];
    return (
        <div className={styles.comp}>
            <EcoSpaceSmall />
            <div className="compare-section-container">
                <EcoCompareProduct items={itemsA} />
            </div>
        </div>
    );
}
